import createIntentStore from "./intentStore";

const store = createIntentStore("checkout:paystack");

export const savePendingPaystack = store.save;
export const readPendingPaystack = store.read;
export const takePendingPaystack = store.take;
export const clearPendingPaystack = store.clear;

export const readUrlParam = (search, name) => {
  const query = String(search || "");
  const match = new RegExp(`[?&]${name}=([^&#]*)`, "i").exec(
    query && !/^[?&]/.test(query) ? `?${query}` : query
  );

  if (!match) return null;

  try {
    return decodeURIComponent(match[1]) || null;
  } catch {
    return match[1] || null;
  }
};

export const referenceFromLocation = (search) =>
  readUrlParam(search, "trxref") || readUrlParam(search, "reference") || null;
